import React, { useCallback, useMemo, useState } from 'react';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useScrollTrigger, Zoom } from '@mui/material';

import useStyles from './styles';

function useScrollTopButton(options = {}) {
    const { scrollable, disableHysteresis = true, threshold = 100, behavior = 'smooth' } = options;

    const { classes } = useStyles();
    const [target, setTarget] = useState(scrollable || undefined);
    const trigger = useScrollTrigger({ target, disableHysteresis, threshold });

    const setScrollable = useCallback((node) => node && setTarget(node), []);

    const scrollTop = useCallback(
        () => target && target.scrollTo({ top: 0, left: target.offsetLeft, behavior }),
        [behavior, target]
    );

    const scrollTopButton = useMemo(
        () => (
            <Zoom in={trigger}>
                <div onClick={scrollTop} role="presentation" className={classes.container}>
                    <ArrowUpwardIcon className={classes.icon} />
                </div>
            </Zoom>
        ),
        [classes.container, classes.icon, scrollTop, trigger]
    );

    return { setScrollable, scrollTopButton, scrollTop };
}

export default useScrollTopButton;
